export const SEGURIDAD = 1;
export const VENTA = 2;
export const LOGISTICA = 3;
export const TESORERIA = 4;
export const CREDITO_COBRANZA = 5;
export const ADMINISTRACION = 6;
export const CONTABILIDAD = 7;
